import { useTranslations } from "next-intl";
import { ChangeEvent, Dispatch, memo, SetStateAction } from "react";
import QuantityControl from "src/components/quantity-control/QuantityControl";

interface QuantityControlContainerProps {
  maxQuantity: number;
  quantity: string | number;
  setQuantity: (
    state: SetStateAction<number | "">,
    cb?: ((state: SetStateAction<number | "">) => void) | undefined
  ) => void;
  disabled: boolean;
  quantityFromCart: number;
  quantityError: null | string;
  setQuantityError: Dispatch<SetStateAction<string | null>>;
}

function QuantityControlContainer({
  maxQuantity,
  quantity,
  setQuantity,
  disabled,
  quantityFromCart,
  quantityError,
  setQuantityError,
}: QuantityControlContainerProps) {
  const t = useTranslations("ProductOverview");

  const handleQuantityInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    const inputToInteger = parseInt(value);
    const isInteger = Number.isInteger(inputToInteger);
    if (isInteger) {
      if (inputToInteger > maxQuantity) {
        setQuantity(maxQuantity, () =>
          setQuantityError(t("max_quantity_message"))
        );
      } else if (inputToInteger < 1) {
        setQuantityError(t("min_quantity_message"));
      } else {
        setQuantity(inputToInteger);
      }
    } else if (value === "") {
      setQuantity(value);
    } else if (value.includes("e") || value.includes(".")) {
      setQuantity((oldQuantity) => oldQuantity);
    }
  };

  const handleQuantityPlusClick = () => {
    if (quantity === "") setQuantity(1);
    else if (typeof quantity === "number") {
      console.log({ quantity, maxQuantity });
      if (quantity >= maxQuantity) setQuantityError(t("max_quantity_message"));
      else setQuantity((oldQuantity) => Number(oldQuantity) + 1);
    }
  };

  const handleQuantityMinusClick = () => {
    if (quantity === "" || Number(quantity) <= 1)
      setQuantityError(t("min_quantity_message"));
    else if (Number.isInteger(quantity)) {
      setQuantity((oldQuantity) => Number(oldQuantity) - 1);
    }
  };

  return (
    <QuantityControl
      className="inline-flex"
      quantity={typeof quantity === "number" ? quantity : ""}
      quantityError={quantityError}
      setQuantityError={setQuantityError}
      onInputChange={handleQuantityInputChange}
      onPlusClick={handleQuantityPlusClick}
      onMinusClick={handleQuantityMinusClick}
      disabled={disabled}
    />
  );
}

export default memo(QuantityControlContainer);
